import React, { useEffect, useState } from "react";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import Loader from "../components/Loader";
import { useParams } from "react-router";
import { Helmet } from "react-helmet";
import { getDecryptedData } from "../config/crypto";

export default function MypurchasePrompts() {
   const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]);
  const { id } = useParams();
  

  

  const fetchPurchasedCategories = async () => {
    console.log("🔥 fetchPurchasedCategories CALLED");
  try {
    setIsLoading(true);

    const token = getDecryptedData('token')


    const res = await axios.get(
      `${REACT_APP_API_PORT}user/prompts_bundle/user/prompt-bundle/categories`,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        }
      }
    );

    if (res.data.status) {
      setCategories(res.data.categories || []);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setIsLoading(false);
  }
};


  useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  fetchPurchasedCategories();
}, []);



  const toggleReadMore = (id) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const loadMore = () => {
    setVisibleCount((prev) => prev + 6);
  };

  return (
    <>
      <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
      <Loader isLoading={isLoading} />
      <Header />
      <div className="min-h-screen bg-black text-white p-4 pt-24 md:pt-28">
  <h2 className="text-center text-4xl md:text-5xl font-bold mb-10">
    Purchased{" "}
    <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#f55fff] to-[#0047FF]">
      Prompt Categories
    </span>
  </h2>

  {isLoading ? (
  <p className="text-center text-gray-400">Loading...</p>
  ) : categories.length === 0 ? (
    <p className="text-center text-gray-400">No Purchased Prompts</p>
  ) : (
    <div className="overflow-x-auto max-w-6xl mx-auto">
      <table className="w-full border border-gray-700 rounded-xl overflow-hidden">
        <thead className="bg-[#1c1c1e]">
          <tr className="text-left text-sm text-gray-300">
            <th className="p-4">Image</th>
            <th className="p-4">Category</th>
            <th className="p-4">Description</th>
            <th className="p-4 text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          {categories.slice(0, visibleCount).map((cat) => (
            <tr
              key={cat._id}
              className="border-t border-gray-700 hover:bg-[#222]"
            >
              {/* IMAGE */}
              <td className="p-4">
                <img
                  src={IMAGE_URL + cat.image}
                  onError={(e) =>
                    (e.target.src = "/just-launch-default.png")
                  }
                  alt={cat.category_name}
                  className="w-16 h-16 object-cover rounded-lg"
                />
              </td>

              {/* NAME */}
              <td className="p-4 font-semibold text-[#00AAE6]">
                {cat.category_name}
              </td>

              {/* DESCRIPTION */}
              <td className="p-4 text-sm text-gray-400 max-w-xs">
                {cat.description}
              </td>

              {/* ACTION */}
              <td className="p-4 text-center">
                <button
                  onClick={() =>
                    (window.location.href = `/my-prompts-bundle/cateory/${cat._id}`)
                  }
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg
                  bg-gradient-to-r from-[#d54d09] via-[#e1307a] to-[#436cff]
                  hover:opacity-90 transition text-sm"
                >
                  👁 View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )}


  {visibleCount < categories.length && (
    <div className="flex justify-center mt-8">
      <button
        onClick={() => setVisibleCount((p) => p + 6)}
        className="border border-blue-500 px-6 py-2 rounded-md hover:bg-blue-600"
      >
        Load More
      </button>
    </div>
  )}
</div>


      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
}
